import React from 'react';
import { Icon, IconProps } from './Icon';

export const CircleInfoIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon
      strokeWidth={0.1}
      viewBox="0 0 18 18"
      height="18"
      width="18"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.875 9C0.875 4.5142 4.5142 0.875 9 0.875C13.4858 0.875 17.125 4.5142 17.125 9C17.125 13.4858 13.4858 17.125 9 17.125C4.5142 17.125 0.875 13.4858 0.875 9ZM15.875 9C15.875 5.20455 12.7954 2.125 9 2.125C5.20455 2.125 2.125 5.20455 2.125 9C2.125 12.7954 5.20455 15.875 9 15.875C12.7954 15.875 15.875 12.7954 15.875 9ZM9.00661 4.6271L8.9915 4.62706C8.76103 4.62928 8.54136 4.72505 8.3829 4.89244C8.22443 5.05984 8.14081 5.28448 8.15127 5.51476L8.37553 10.2795C8.41291 11.0737 9.58683 11.0736 9.62415 10.2794L9.84798 5.51576C9.85861 5.28166 9.7728 5.05447 9.61077 4.88655C9.45854 4.72881 9.25132 4.63614 9.03255 4.62766L9.01745 4.62726L9.00661 4.6271ZM8.21875 12.5902C8.21875 13.0217 8.56853 13.3714 9 13.3714C9.43147 13.3714 9.78125 13.0217 9.78125 12.5902C9.78125 12.1587 9.43147 11.8089 9 11.8089C8.56853 11.8089 8.21875 12.1587 8.21875 12.5902Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </Icon>
  );
};
